export default __webpack_public_path__ + "static/logo-betong-negativ-23e9ccf31cfc0e52c7d843ae598fc471.png";